import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient, initQueryPersistence } from '@/lib/query-cache.js';
import { AuthGuard } from '@/components/AuthGuard.js';
import { Layout } from '@/components/Layout.js';
import { LoginPage } from '@/features/auth/LoginPage.js';
import { ProjectList } from '@/features/projects/ProjectList.js';
import { ProjectDetail } from '@/features/projects/ProjectDetail.js';
import { BoardList } from '@/features/boards/BoardList.js';
import { BoardView } from '@/features/boards/BoardView.js';
import { IssueDetail } from '@/features/issues/IssueDetail.js';
import { SearchPage } from '@/features/search/SearchPage.js';
import { FollowedIssues } from '@/features/follows/FollowedIssues.js';

// Hydrate cache from localStorage (non-blocking)
initQueryPersistence();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <AuthGuard>
                <Layout />
              </AuthGuard>
            }
          >
            <Route index element={<Navigate to="/projects" replace />} />
            <Route path="projects" element={<ProjectList />} />
            <Route path="projects/:key" element={<ProjectDetail />} />
            <Route path="boards" element={<BoardList />} />
            <Route path="boards/:id" element={<BoardView />} />
            <Route path="issues/:key" element={<IssueDetail />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="following" element={<FollowedIssues />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
